// extracted by mini-css-extract-plugin
export var linkText = "_qu-0";